import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';

import ClaimENStep1 from './Claims/ENStep1';
import ClaimENStep2 from './Claims/ENStep2';
import ClaimENStep3 from './Claims/ENStep3';
import ClaimENStep4 from './Claims/ENStep4';
import ClaimENStep5 from './Claims/ENStep5';

import ClaimENValidate from './Claims/ENValidate';

import ClaimENOStep1 from './Claims/Ortho/ENStep1';
import ClaimENOStep2 from './Claims/Ortho/ENStep2';
import ClaimENOStep3 from './Claims/Ortho/ENStep3';
import ClaimENOStep5 from './Claims/Ortho/ENStep5';

import ls from 'local-storage';

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingBottom: '10px',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
        color: theme.palette.text.secondary,
    },
});

function getSteps(formtype) {
    if (formtype === "fp17o") {
        return ['Exemptions', 'Orthodontic Data Set', 'Assess or Completion', 'Save & Submit'];
    } else {
        return ['Treatment Dates', 'Exemptions', 'Treatment Category', 'Clinical Data Set', 'Save & Submit'];
    }
}

function getStepContent(step, data, socket) {

    let claimProps = {
        fp17data: data.fp17data,
        pdata: data.pdata,
        socket: socket
    }

    if (data.form_type === "fp17o") {
        //console.log(data);

        switch (step) {
            case 0:
                return <ClaimENOStep1 {...claimProps}/>;
            case 1:
                return <ClaimENOStep2 {...claimProps}/>;
            case 2:
                return <ClaimENOStep3 {...claimProps}/>;
            case 3:
                return <ClaimENOStep5 {...claimProps}/>;
            default:
                return <ClaimENOStep1 {...claimProps}/>;
        }
    } else {
        switch (step) {
            case 0:
                return <ClaimENStep1 {...claimProps}/>;
            case 1:
                return <ClaimENStep2 {...claimProps}/>;
            case 2:
                return <ClaimENStep3 {...claimProps}/>;
            case 3:
                return <ClaimENStep4 {...claimProps}/>;
            case 4:
                return <ClaimENStep5 {...claimProps}/>;
            default:
                return <ClaimENStep1 {...claimProps}/>;
        }        
    }
}

class NewClaimEN extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;

        //console.log(this.props);
    }

    state = {
        activeStep: 0,
        skipped: new Set(),
        fp17data: {},
        pdata: {previous_claim:{}},
        validationOpen: false,
        form_id: '',
        form_type: this.props.form_type,
        patient_id: this.props.patient_id,
    };

    async componentDidMount() {
        this._isMounted = true;

        this.props.socket.on("claim_save_result",(d)=>{
            if (this._isMounted) {
                //console.log(d);

                if (this.state.validationOpen === true) {
                    // don't close the form, it's being validated
                    this.setState({form_id: d[0].form_id});
                } else {
                    this.props.closeFunction();
                }
            }
        }); 

        this.props.socket.on("claim_config_result",(d)=>{
          if (this._isMounted) {
                //console.log(d);
                this.setState({pdata: d});              
          }
        }); 
        
        if (this.props.form_id)
        {
            this.props.socket.emit("claim_data", {formid:this.props.form_id,authenticator:ls.get("authenticator")});        
            await this.setState({form_id: this.props.form_id});
        }

        if (this._isMounted) {
            this.props.socket.emit("claim_config", {patientid:this.props.patient_id,formid:this.state.form_id,
                                    authenticator:ls.get("authenticator")});
        }

        this.props.socket.on("claim_data_result",(d)=>{
            if (this._isMounted) {
                if (d[0].batch_id) {
                    d[0].form_data.batch_id = d[0].batch_id;
                    d[0].form_data.sqind = '1'; // default action for replacement sqind
                }

                this.setState({fp17data: d[0].form_data});
            }


            //console.log(this.state);             
        });   
     
    }

    componentWillUnmount() {
        this._isMounted = false;
    }     

    isStepOptional = step => step === -1;

    handleNext = () => {
        const { activeStep } = this.state;
        let { skipped } = this.state;
        if (this.isStepSkipped(activeStep)) {
        skipped = new Set(skipped.values());
        skipped.delete(activeStep);
        }
        this.setState({
        activeStep: activeStep + 1,
        skipped,
        });

        let steps = getSteps(this.state.form_type);

        //console.log(this.state.activeStep+' === '+steps.length)

        if (this.state.activeStep + 1 === steps.length) {
            // show the validation form
            //console.log('show validation');
            this.setState({ validationOpen: true });
        }

        //console.log(this.state.fp17data);
    };

    handleBack = () => {
        this.setState(state => ({
        activeStep: state.activeStep - 1,
        }));
    };

    handleSkip = () => {
        const { activeStep } = this.state;
        if (!this.isStepOptional(activeStep)) {
        // You probably want to guard against something like this,
        // it should never occur unless someone's actively trying to break something.
        throw new Error("You can't skip a step that isn't optional.");
        }

        this.setState(state => {
        const skipped = new Set(state.skipped.values());
        skipped.add(activeStep);
        return {
            activeStep: state.activeStep + 1,
            skipped,
        };
        });
    };

    handleReset = () => {
        this.setState({
        activeStep: 0,
        });
    };

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }

    handleSave = () => {
        //console.log(this.state);

        if (this.state.fp17data)
        {
            let datatmp = this.state.fp17data;
            datatmp.formtype = this.state.form_type;
            this.setState({fp17data: datatmp}); 

            this.props.socket.emit("claim_save", {claimstate:this.state,authenticator:ls.get("authenticator")});
        }
        else
        {
            new Error("No claim data to save.");
        }
    }   

    handleValidationClickOpen = () => {
        this.setState({ validationOpen: true });
    };

    handleValidationClose = () => {
        this.setState({ validationOpen: false });
    };    

  render() {
    const { classes } = this.props;
    const steps = getSteps(this.state.form_type);
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
            <Button variant="contained" color="primary" className={classes.button}  onClick={this.handleSave}>Save as Draft</Button>
            <Button variant="contained" color="secondary" className={classes.button} onClick={this.props.closeFunction}>Cancel</Button>
            <span style={{fontWeight:'bold'}}>{this.state.form_type.toUpperCase()}</span>&nbsp;for&nbsp; 
            <span style={{fontWeight:'bold'}}>{this.state.pdata.name}</span>
            { this.state.pdata.previous_claim.band ? ( 
            <span style={{paddingLeft:'8px'}}>
                Previous claim: {this.state.pdata.previous_claim.band} - 
                Completed: {moment(this.state.pdata.previous_claim.datcp).format('DD/MM/YYYY')}
            </span>
            ) : null }
        </Paper>      
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (this.isStepSkipped(index)) {
              props.completed = false;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div style={{margin: 'auto'}}>
              <Typography className={classes.instructions}>
                All steps completed - you&apos;re finished
              </Typography>
              <Button variant="contained" color="secondary" className={classes.button} onClick={this.props.closeFunction}>Close Form</Button>
            </div>
          ) : (
            <div>
              <Typography className={classes.instructions}>{getStepContent(activeStep, this.state, this.props.socket)}</Typography>
              <div style={{float: 'right'}}>
                <Button
                    variant="contained"
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    className={classes.button}
                >
                  Back
                </Button>
                {this.isStepOptional(activeStep) && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSkip}
                    className={classes.button}
                  >
                    Skip
                  </Button>
                )}
                {activeStep < steps.length - 1 ?
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                  className={classes.button}
                >
                  Next
                </Button> : null }
                {activeStep === steps.length - 1 ? 
                <Button
                  variant="contained"
                  style={{backgroundColor:"#00BB00",color:"#FFF"}}
                  onClick={this.handleSave}
                  className={classes.button}
                >
                  Finish & Save
                </Button> : null}
              </div>
            </div>
          )}
        </div>
        <Dialog
            open={this.state.validationOpen}
            onClose={this.handleValidationClose}
            >
            <ClaimENValidate closeFunction={this.handleValidationClose} patient_id={this.state.patient_id} 
                socket={this.props.socket} form_id={this.state.form_id} fp17data={this.state.fp17data}
                source="claim_edit" formSaveFunction={this.handleSave}/>
        </Dialog>        
      </div>
    );
  }
}

NewClaimEN.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(NewClaimEN);